import OnIdle from '@mindtickle/ui-shell-core/IdleUntilUrgent';
import { isAdminSite } from '~/utils';

import AdminLayout from './Admin';
import LearnerLayout from './Learner';

import DeferredIntegrations from '~/components/Integrations/components/DeferredIntegrations';

type TLayoutProps = { children: JSX.Element; hideLayout: () => boolean };

export const Layout = (props: TLayoutProps) => {
  const isAdmin = !!isAdminSite();
  const LayoutComponent = isAdmin ? AdminLayout : LearnerLayout;

  let children = (
    <>
      {props.children}
      <OnIdle>
        <DeferredIntegrations />
      </OnIdle>
    </>
  );

  if (props.hideLayout()) {
    return children;
  }

  return <LayoutComponent>{children}</LayoutComponent>;
};
